import { render, staticRenderFns } from "./CampaignContent.vue?vue&type=template&id=00b578f5&scoped=true"
import script from "./CampaignContent.vue?vue&type=script&lang=js"
export * from "./CampaignContent.vue?vue&type=script&lang=js"
import style0 from "./CampaignContent.vue?vue&type=style&index=0&id=00b578f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b578f5",
  null
  
)

export default component.exports